import Vue from 'vue';
import Vuex from 'vuex';
import { oidcSettings, oidcStoreSettings } from '../config/oidc-config';
import { argoSettings } from '../config/argo-config';
import { vuexOidcCreateStoreModule } from 'vuex-oidc';
import { vuexArgoCreateStoreModule } from './module/session';
import createMutationsSharer from 'vuex-shared-mutations';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createMutationsSharer({ 
      predicate: [ 'argoStore/broadcastLogout' ],
    })
  ],
   
  modules: {
    oidcStore: vuexOidcCreateStoreModule(oidcSettings, oidcStoreSettings),
    argoStore: vuexArgoCreateStoreModule(argoSettings),
  }
});
